"use client"
import React, { useState, useEffect } from "react"
import * as classes from "./diagramSection.module.scss"
import { useBreakpoint } from "../../../../hooks/breakpoints"
import SlideWrapper from "@/components/Shared/SlideWrapper/slideWrapper"

const DiagramSection = ({ DiagramData, theme }) => {
  const breakpoint = useBreakpoint()
  const [orderedData, setOrderedData] = useState([])

  useEffect(() => {
    const x = DiagramData.sort((a, b) => {
      return a.order > b.order ? 1 : -1
    })
    setOrderedData(x)
  }, [DiagramData])

  return (
    <div>
      {orderedData.map((i, index) => {
        return (
          <>
            {!!i.heading && (
              <div
                className={classes["diagramSectionWrapper"]}
                key={i.dateDescriptionLine1 + `${index}`}
                style={
                  breakpoint.sm
                    ? { display: "flex", fontFamily: theme.fontFamilyPrimary }
                    : index % 2 === 0
                    ? {
                        flexDirection: "row-reverse",
                        fontFamily: theme.fontFamilyPrimary,
                      }
                    : {
                        flexDirection: "row",
                        fontFamily: theme.fontFamilyPrimary,
                      }
                }
              >
                <SlideWrapper
                  triggerOnce
                  direction={index % 2 === 0 ? "right" : "left"}
                  delay={200}
                  duration={600}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <div className={classes["diagramImage"]}>
                    <img src={i.imageSrc} alt="Diagram Sections img" />
                  </div>
                </SlideWrapper>

                <SlideWrapper
                  triggerOnce
                  direction={index % 2 === 0 ? "left" : "right"}
                  delay={200}
                  duration={600}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <div
                    className={classes["diagramDetails"]}
                    style={{ color: theme.secondaryTextColor }}
                  >
                    <div
                      className={classes["dateSection"]}
                      style={{ color: theme.primaryTextColor }}
                    >
                      {i.period}
                    </div>
                    <div style={{ color: theme.primaryTextColor }}>
                      <div>{i.dateDescriptionLine1} </div>
                      <div>{i.dateDescriptionLine2}</div>
                    </div>

                    <div
                      className={classes["headingSection"]}
                      style={{ color: theme.primaryTextColor }}
                    >
                      {" "}
                      {i.heading}
                    </div>
                    <div
                      className={classes["descriptionSection"]}
                      style={{ color: theme.secondaryTextColor }}
                    >
                      <div>{i.descriptionLine1}</div>
                      <div>{i.descriptionLine2}</div>
                    </div>
                  </div>
                </SlideWrapper>
              </div>
            )}
          </>
        )
      })}
    </div>
  )
}

export default DiagramSection
